import React from 'react';

const TWHeader = (props:any) =>
{
	const { joinDetails } = props;

	return (
		<div className='flexRow alignCntr justifyCntr pdngSM'>
			<div className='flexAutoRow authLogo'>
				<img src={'/images/logos/In_logo.svg'} alt='inLynk-logo' height='32' width='120'/>
			</div>
			<div className='flexMinWidthRow pdngHSM'>
				<span className='subHeadingSM capitalTxt'>{joinDetails?.type ? (joinDetails?.type === 'training' ? 'meeting' : joinDetails?.type) : '' }</span>
			</div>
		</div>
	);
};

export default TWHeader;